// AGENT-R: small Zustand store that drives the Data-Drill drawer (DataDrillDrawer.tsx).
//
// Two modes:
//   - "visual"    → drawer renders the joined pre-aggregation rows behind a single
//                   visual (clicked via the "..." button in _chartShell).
//   - "rawTables" → drawer renders a tabbed view across the source tables
//                   (Invoice / Item Analysis / Product Table / Client). Opened by
//                   the top-bar "View Raw Tables" button via the
//                   `hsq:open-raw-tables` window event (Agent L dispatches it).
//
// Closing the drawer resets both fields. Mode is the single source of truth for
// which body the drawer shows.

import { create } from "zustand";

export type DrillMode = "visual" | "rawTables" | null;

export interface DrillState {
  mode: DrillMode;
  visualId: string | null;
  openVisual: (id: string) => void;
  openRawTables: () => void;
  close: () => void;
}

export const useDrillStore = create<DrillState>((set) => ({
  mode: null,
  visualId: null,
  openVisual: (id: string) => set({ mode: "visual", visualId: id }),
  openRawTables: () => set({ mode: "rawTables", visualId: null }),
  close: () => set({ mode: null, visualId: null }),
}));
